import { ViewModelItemTitle } from '../../items';
import { useCallback, useMemo, useState } from 'react';
import { includeViewsAtom, searchResultsAtom, type ViewModelJSON } from '../SearchResult/trpcSearchResultState';
import { useAtomValue } from 'jotai';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { KataSearchViewItem } from './KataSearchViewItem';

type Props = {
  viewModel: ViewModelJSON;
  searchKeyword: string;
};

export const KataSearchViewModelItem: React.FC<Props> = ({ viewModel, searchKeyword }: Props) => {
  const [isOpen, setIsOpen] = useState(true);

  const includeViews = useAtomValue(includeViewsAtom);
  const trpcResults = useAtomValue(searchResultsAtom);

  const sortedViews = useMemo(() => {
    if (!includeViews) return [];

    if (!trpcResults) return [];

    const { views } = trpcResults.kataResults;
    if (!views || !views[viewModel.id]) return [];

    return views[viewModel.id].sort((a, b) => a.name.localeCompare(b.name));
  }, [includeViews, trpcResults, viewModel.id]);

  const toggleOpen = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return (
    <div className="relative">
      <div className={'flex items-center'}>
        {includeViews && (
          <button className="mr-1 w-4 focus:outline-none" onClick={toggleOpen}>
            <FontAwesomeIcon icon={isOpen ? faCaretDown : faCaretRight} className="size-4" />
          </button>
        )}
        <div className="grow hover:bg-gray-300">
          <ViewModelItemTitle
            viewModelId={viewModel.id}
            isViewModelPublicReadable={viewModel.isPublicReadable}
            isIndividualPermissionConfigured={false} // KATA の検索結果では個別権限のアイコンは常に非表示
            isLocked={viewModel.isLocked}
            viewModelName={viewModel.name.toString()}
            searchKeyword={searchKeyword}
          />
        </div>
      </div>

      {isOpen && (
        <div className="ml-5">
          {sortedViews.map((view) => (
            <KataSearchViewItem key={view.id} view={view} viewModel={viewModel} searchKeyword={searchKeyword} />
          ))}
        </div>
      )}
    </div>
  );
};
